<template>
    <div>
        <div class="about-us">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <!-- About Image Start -->
                    <div class="about-image">
                        <div class="about-img-1">
                           
                                <img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2FImagen%20de%20WhatsApp%202025-01-13%20a%20las%2019.44.12_365b27ca.jpg?alt=media&token=4f064256-2ce6-408a-93c0-cc60aaf1822e" alt="">
                            
                        </div>

                        <div class="about-img-2">
                            
                                <img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2Fabout-us-img-2.jpg?alt=media&token=3c21ac73-d87a-44a7-b82e-48798d45e787" alt="">
                            
                        </div>

                        <!-- About Experience Circle Start -->
                        <div class="about-experience">
                            
                                <img src="https://firebasestorage.googleapis.com/v0/b/usdadental-6e620.appspot.com/o/images%2Fabout-experience-circle.png?alt=media&token=ee407dde-e563-4f0e-9f7a-2ac995d3abfc" alt="">
                           
                        </div>
                        <!-- About Experience Circle End -->
                    </div>
                    <!-- About Image End -->
                </div>

                <div class="col-lg-6">
                    <!-- About Content Start -->
                    <div class="about-content">
                        <!-- Section Title Start -->
                        <div class="section-title">
                            <h3 class="wow fadeInUp">¿Quienes somos?</h3>
                            <h2 class="text-anime-style-2" data-cursor="-opaque"><span>Tu viaje</span> hacia una sonrisa más saludable comienza aquí</h2>
                            <p class="wow fadeInUp" data-wow-delay="0.25s">El objetivo de nuestro consultorio es brindar una odontología amable y atenta y el más alto nivel de tratamientos dentales generales y especializados.</p>
                        </div>
                        <!-- Section Title End -->

                        <!-- About Us Body Start -->
                        <div class="about-us-body wow fadeInUp" data-wow-delay="0.5s">
                            <ul>
                                <li>Equipo Experimentado</li>
                                <li>Servicios integrales</li>
                                <li>Area comoda</li>
                                <li>Servicios dentales de urgencia</li>
                            </ul>
                        </div>
                        <!-- About Us Body End -->

                        <!-- About Us Footer Start -->
                        <!-- <div class="about-us-footer wow fadeInUp" data-wow-delay="0.75s">
                            <a href="#" class="btn-default">read more about us</a>
                        </div> -->
                        <!-- About Us Footer End -->
                    </div>
                    <!-- About Content End -->
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
 
};
</script>


